<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '520px' }"
    :header="title"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="field">
      <label for="credential">Matricula</label>
      <InputText
        id="credential"
        placeholder="Digite a matricula"
        v-model="obj.credential"
        @change="findPerson"
        required
      />
      <div v-if="obj.person">
        <br />
        <Chip :label="obj.name" :image="obj.url" class="mr-2 mb-2" />
      </div>
    </div>
    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.obj.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Operator from "../../../models/internal/operator";

//Services
import OperatorService from "../../../service/operator/operator_service";
import PersonService from "../../../service/person/person_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["objSelected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      obj: new Operator(),
      submitted: false,
      service: new OperatorService(),
      title: "Novo Operador",
      personService: new PersonService(),
    };
  },
  mounted() {},
  validations() {
    return {
      obj: new Operator().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.operator.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.operator.dialogForm = value;
      },
    },
  },
  methods: {
    findPerson() {
      this.personService
        .findByCpfOrCredential(this.obj.credential)
        .then((data) => {
          this.obj.person = data.id;
          this.obj.credential = data.credential;
          this.obj.name = data.name;
        });
    },
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.obj.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      let obj2 = new Operator();
      obj2.getData(this.obj);
      this.service
        .create(obj2.toJson())
        .then((data) => {
          if (data.status === 201) {
            this.$toast.add({
              severity: "success",
              summary: "Alerta!",
              detail: "Registro cadastrado com sucesso.",
              life: 3000,
            });
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      let obj2 = new Operator();
      obj2.getData(this.obj);
      this.service
        .update(obj2.toJson())
        .then((data) => {
          if (data.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "Alerta!",
              detail: "Registro alterado com sucesso.",
              life: 3000,
            });
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.obj = new Operator();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.obj = this.objSelected;
      this.title = this.obj.id == null ? "Novo Operador" : this.obj.name;
    },
  },
};
</script>
<style scoped></style>
